import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Hours spent searching for drills and session ideas', 'Repeating the same exercises because they are easy to remember', 'Sessions that feel disconnected instead of progressive', 'Athletes doing drills without understanding the purpose', 'Difficulty adapting work for beginner, intermediate and advanced boxers', 'Too many corrections at once', 'Conditioning that starts to replace technical development', 'Last-minute sessions when your original plan no longer works', 'Uncertainty about what an athlete should work on next', 'Free time disappearing into planning'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-base" data-id="element-160" data-mp="1sy4yg8jxjkyb">
      <div className="max-w-3xl mx-auto" data-id="element-161" data-mp="1sz6k16yknpua">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-162" data-mp="3idungip6pxg6">
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-163" data-mp="1yyu7pcytq1c7">
            The Sunday-night coaching problem
          </p>
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-164" data-mp="27ti92s1a2yvq">
            Sound familiar?
          </h2>
          <p className="text-lg text-graphite leading-relaxed bg-cream-light p-6 rounded-2xl border border-silver-light text-left" data-id="element-165" data-mp="23rx2fofc7gtz">
            Sunday night. You have athletes arriving tomorrow. And instead of switching off, you are
            still thinking about the next session. What should you work on? Which drills should you
            use? How do you make the session different from last week? How do you progress the
            athlete without jumping ahead too quickly? How do you combine technique, footwork,
            defense, pads, bag work, conditioning and tactics into one session that actually makes
            sense?
            <br data-id="element-166" data-mp="1t559k5d3uruw" />
            <br data-id="element-167" data-mp="1t5ohct91jzv7" />
            <span className="text-accent-dark font-semibold" data-id="element-168" data-mp="1t43nl5ujwkye">
              Not because you do not understand boxing.
            </span>{' '}
            You already understand boxing. The problem is that you have been forced to turn that
            knowledge into complete sessions over and over again. Every week. Every athlete. Every
            group. Every level. And that takes time.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="space-y-6" data-id="element-169" data-mp="1ag8h8719q9fb">
          <h3 className="text-xl font-bold text-ink mb-8 text-center" data-id="element-170" data-mp="1o6ln83ulne20">
            The real cost of planning everything from scratch:
          </h3>
          <ul className="space-y-4" data-id="element-171" data-mp="qqeh95oego00">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-paper p-4 rounded-xl border border-silver-light" data-id="element-172" data-mp="vo6kuwyepyk1" data-mpi={index}>
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" aria-hidden="true" data-id="element-173" data-mp="a67dzmz65y63" />
                <span className="text-graphite" data-id="element-174" data-mp="g5oqrv2y9pl">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-silver-light" data-id="element-175" data-mp="3ro0dgzo2snsq">
            <p className="text-2xl font-display font-extrabold text-ink" data-id="element-176" data-mp="3modyolslmzht">
              Your coaching knowledge is already there. What you need is a system that helps you
              organize and use it.
            </p>
            <p className="text-xl mt-4 text-accent-dark font-semibold" data-id="element-177" data-mp="3do8uslmm6j8e">
              Plan an entire year of boxing sessions today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}